import { useMutation } from '@apollo/client';
import { RemoveNotification } from 'graphqlDocuments/mutations';

export default function NotificationsContainer(WrappedComponent) {
  return function NotificationsContainerWrapper(props) {
    const [removeNotificationMutation] = useMutation(RemoveNotification);

    return (
      <WrappedComponent
        {...props}
        removeNotification={(variables) =>
          removeNotificationMutation({
            variables,
          })
        }
      />
    );
  };
}
